import React, {useRef, useState, useEffect} from "react";
import {Row, Col, Container, Button} from "react-bootstrap";
import {localStorage, window} from "window-or-global";
import Modal from "../../components/bootstrap/modal";
import Formsy from "formsy-react";
import AltTextField from "../../components/bootstrap/input-alt";
import PlanSlider from "../../components/plan-slider";
import { setFormData } from "../../components/manager/form";

// function getLo() {
//   return JSON.parse(localStorage.getItem("userPlan"));
// }
function setLocalDetails(plan) {
  localStorage.setItem("userDetails", JSON.stringify(plan));
}



export default function SignUpControl() {
  const formRef = useRef(null);
  const [processing, setProcessing] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);

  function handleValid(model) {
    setIsFormValid(true);
  }
  function handleInvalid(model) {
    setIsFormValid(false);
  }
  function handleValidSubmit(model) {
    setProcessing(true);
    try {
      setFormData(model);
      window.location.replace("/select-address");
    } catch(e) {
      console.error(e);
    }
    setProcessing(false);
  }


  return (
    <div className="vw-signup-panel">
      <Formsy ref={formRef} onValidSubmit={handleValidSubmit} onInvalid={handleInvalid} onValid={handleValid}>
        <Row className="field-row-user-info">
          <Col xs={12} lg={12} xl={12} className="vw-user-fname-field">
            <AltTextField
              placeholder={"First Name"}
              hideRequiredMark
              name="firstName"
              required
              autoComplete="off"
              prefix={
                <img
                  alt="user-icon"
                  src=""
                  className="field-icon"
                />
              }
              disabled={processing}
            />
          </Col>
          <Col xs={12} lg={12} xl={12} className="vw-user-lname-field">
            <AltTextField
              placeholder={"Last Name"}
              hideRequiredMark
              prefix={
                <img
                  alt="user-icon"
                  src=""
                  className="field-icon"
                />
              }
              name="lastName"
              required
              autoComplete="off"
              disabled={processing}
            />
          </Col>
        </Row>
        {/* <Row className="field-row-password-info">
          <Col xs={12} className="vw-user-password-field">
            <AltTextField
              placeholder={"Password"}
              hideRequiredMark
              name="password"
              required
              type={passwordShow ? "text" : "password"}
              autoComplete="off"
              disabled={processing}
              validations="minLength:8"
              validationError="Password must be 8 characters long"
              prefix={passwordShow ?
                <i
                  className="fas fa-eye pass-icon"
                  onClick={() => setPasswordShow(false)}
                />
                :
                <i
                  className="fas fa-eye-slash pass-icon"
                  onClick={() => setPasswordShow(true)}
                />
              }
            />
          </Col>
          <Col xs={12} className="vw-user-confirm-password-field">
            <AltTextField
              placeholder={"Confirm Password"}
              hideRequiredMark
              name="confirm_password"
              required
              type="password"
              autoComplete="off"
              validations="equalsField:password"
              validationError="Passwords don't match"
              prefix={
                <img
                  alt="confirm-password-icon"
                  src=""
                  className="field-icon"
                />
              }
              disabled={processing}
            />
          </Col>
        </Row> */}
        <Row className="field-row-contact-info">
          <Col xs={12} className="vw-user-email-field">
            <AltTextField
              placeholder={"Email"}
              hideRequiredMark
              name="email"
              validations="isEmail"
              validationError="This is not a valid email"
              required
              prefix={
                <i
                  className="fa fa-envelope"
                />
              }
              type="email"
              autoComplete="off"
              disabled={processing}
            />
          </Col>
          <Col xs={12} className="vw-user-mobile-field">
            <AltTextField
              placeholder={"Mobile"}
              hideRequiredMark
              name="mobileNumber"
              required
              type="number"
              autoComplete="off"
              validations="isNumeric,minLength:7,maxLength:12"
              validationError="This is not a valid mobile number"
              prefix={
                <img
                  alt="mobile-icon"
                  src=""
                  className="field-icon"
                />
              }
              disabled={processing}
            />
          </Col>
        </Row>
        <PlanSlider name="selectedProduct" required />
        <div className="signup-actionss">
          <Button className={`action-${isFormValid ? "continue" : "disabled"}`}
            type="submit"
            disabled={!isFormValid}
          >
            {processing ? (<i className="fa fa-circle-o-notch fa-spin" />) : "Continue"}
          </Button>
        </div>

      </Formsy>
    </div>
  );
}
